module.exports = __webpack_public_path__ + "img/webcam.ddd650f8.svg";